import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { HostService } from "./host.service";

@Injectable({
    providedIn: 'root'
})
export class DatosAbiertosTesisService {
  
    private apiUrl = this.hostService.getHostRoot() + environment.apiEstadisticos;
    private readonly ConfigConstantes: string = './assets/json/';
    constructor(private http: HttpClient, private hostService: HostService) { }

    getApis(): Observable<any> {
        return this.http.get<any>(`${this.ConfigConstantes}table-tesis.json`);
    }

    graphTesis(inicio: number, fin: number): Observable<any> {
        const options = new HttpParams()
                        .set('anio-ini', inicio)
                        .set('anio-fin', fin);
    
        return this.http.get<any>(`${this.apiUrl}/estadisticos/tesis/grafica-principal`, { params: options });
    }

    getData(epoca: number, api: string): Observable<any> {
        const options = new HttpParams()
                        .set('epoca', epoca);
    
        return this.http.get<any>(`${this.apiUrl}/${api}`, { params: options });
    }
}